import { Quill } from 'vue-quill-editor';

const files = require.context('.', false, /\.js$/);

files.keys().forEach((key) => {
	if (key === './index.js') return;
	Quill.register(files(key).default, true);
});
